export default __webpack_public_path__ + "static/assets/phone_hand.3adc56c4.png";